<!-- 设置方案 -->
<template>
  <div class="gwnl-position-eval__info pb40">
    <yxt-form
      ref="form"
      v-loading="loading"
      :rules="rules"
      :model="form"
      label-width="100px"
      is-need-require
      label-position="top"
    >
      <yxt-blockhead
        class="mt50"
        :title="$t('pc_base_info')"
        size="small"
        type="special"
      />
      <div class="ml16 mt8">
        <yxt-form-item
          :label="$t('pc_gwnl_global_lbl_projectName')"
          prop="name"
        >
          <yxt-input
            v-model="form.name"
            maxlength="50"
            :placeholder="$t('pc_gwnl_global_enterProjectName')"
            show-word-limit
          />
        </yxt-form-item>
        <yxt-form-item
          :label="$t('pc_gwnl_web_lbl_survey_information_hint')"
          prop="description"
        >
          <yxt-input
            v-model="form.description"
            type="textarea"
            :rows="3"
            maxlength="200"
            :placeholder="$t('pc_gwnl_web_pleaseEnter') + $t('pc_gwnl_web_lbl_survey_information_hint')"
            show-word-limit
          />
        </yxt-form-item>
      </div>
      <yxt-blockhead
        :title="$t('pc_talent_lbl_eval_content').d('评估内容')"
        size="small"
        type="special"
      />
      <yxt-form-item class="ml16">
        <span class="color-red">{{ $t('pc_talent_msg_eval_not_pass').d('对未达到标准的能力项进行评估') }}</span>
      </yxt-form-item>
      <yxt-blockhead
        class="mt32"
        :title="$t('pc_gwnl_eval_evalSettings')"
        size="small"
        type="special"
      />
      <div class="ml16 mt8">
        <yxt-form-item
          size="small"
          :label="$t('pc_talent_lbl_sync_relationship').d('评估关系同步')"
        >
          <yxt-switch
            :disabled="!!id"
            v-model="form.autoSync"
            :active-value='1'
            :inactive-value='0'
            @change="onAutoSyncChanged"
          />
          <span class="ml4">{{ $t('pc_talent_lbl_eval_sync_relationship').d('自动同步上一次评估任务的评估关系内容') }}</span>
          <yxt-tooltip
            effect="dark"
            placement="top"
            :content="$t('pc_talent_tips_sync_relationship').d('设置成功后，点击下一步再返回此选项无法进行二次编辑')"
          >
            <yxt-svg
              class="ml4 color-gray-6 hand v-mid"
              width="16px"
              height="16px"
              icon-class="question-cirlce-o"
            />
          </yxt-tooltip>
        </yxt-form-item>
        <yxt-form-item
          v-show="!form.autoSync"
          :label="$t('pc_gwnl_eval_evalRelationship')"
          required
          prop='evaluationConfig4Create'
        >
          <div class='flex-col flex' :class="{'eval-custom-checkbox': !expend}">
            <div
              v-for="item in dimensionInfo"
              :key="item.type"
            >
              <!-- 其他评估关系 -->
              <yxt-checkbox
                v-if="item.type !== '2'"
                v-model='form.evaluationConfig4Create[item.prop]'
                :true-label='1'
                :false-label='0'
                :disabled="disabledRelationBox(item)"
                @change="changeEnable(form.evaluationConfig4Create[item.prop], item.type)"
              >
                <eval-tooltip :label="item.label" :disabledFunc="disabledRelationBox(item)" />
              </yxt-checkbox>
              <!-- 上级评估 -->
              <template v-else>
                <yxt-checkbox
                  v-model='form.evaluationConfig4Create.enabledLeader'
                  :true-label='1'
                  :false-label='0'
                  :label="$t('pc_gwnl_global_leaderAssessment')"
                  :disabled="disabledRelationBox(item)"
                  @change='changeLeaderEnable'
                >
                  <eval-tooltip :label="$t('pc_gwnl_global_leaderAssessment')" :disabledFunc="disabledRelationBox(item)" />
                </yxt-checkbox>
                <template v-if='form.evaluationConfig4Create.enabledLeader === 1'>
                  <yxt-radio
                    v-model="leaderType"
                    label="enabledLeaderPm"
                    @change="changeLeaderType"
                  >
                    {{ $t('pc_gwnl_eval_departmentManager') }}
                  </yxt-radio>
                  <yxt-radio
                    v-model="leaderType"
                    label="enabledLeaderDm"
                    @change="changeLeaderType"
                  >
                    {{ $t('pc_gwnl_eval_directManager') }}
                  </yxt-radio>
                </template>
              </template>
            </div>
          </div>

          <div v-if="dimensionInfo && dimensionInfo.length > 6" class="eval-custom-text hand" @click="expend = !expend">
            <span class="color-primary-6">{{ expend ? $t('pc_gwnl_clamp_retract' /* 收起 */) : $t('pc_comp_sideBar_open' /* 展开 */) }}</span>
            <yxt-svg
              width="14px"
              height="14px"
              :icon-class="expend ? 'arrow-up' : 'arrow-down'"
              class="color-primary-6 ml4" />
          </div>
        </yxt-form-item>
        <div v-if='form.autoSync || (weightList && weightList.length > 1)'>
          <yxt-form-item
            :label="$t('pc_gwnl_eval_lbl_evalWeight')"
            prop='weight'
            :label-tooltip="$t('pc_gwnl_eval_weightSettingTooltip')"
            size="small"
            required
          >
            <div class='flex flex-col'>
              <yxt-radio
                v-model='form.evaluationConfig4Create.weightType'
                :label='1'
                @change='setAverageWeight'
              >
                {{ $t('pc_gwnl_eval_averageWeight') }}
              </yxt-radio>
              <div>
                <yxt-radio
                  v-model='form.evaluationConfig4Create.weightType'
                  :label='2'
                  @change='setAverageWeight'
                >
                  {{ $t('pc_gwnl_eval_customWeight') }}
                </yxt-radio>
                <div v-if='parseInt(form.evaluationConfig4Create.weightType) === 2' class="flex flex-wrap mt12 bg-lightgrey pl16 pt16 pb8 yxtbizf-br-4">
                  <div
                    v-for='item in weightList'
                    :key='item.weight'
                    class='flex weight-item mb8'
                  >
                    <yxt-tooltip :content="item.label" placement="top" open-filter>
                      <span class='mr8 ellipsis'>{{ item.label }}</span>
                    </yxt-tooltip>
                    <yxt-input-number
                      v-model='weight[item.weight]'
                      class="yxtbiz-flex-shrink-0"
                      :precision='0'
                      :min='0'
                      :max='100'
                      :formatter='handleFormatter'
                    />
                  </div>
                </div>
              </div>
            </div>
          </yxt-form-item>
          <yxt-form-item
            :label="$t('pc_talent_lbl_other_eval_rule').d('他评分计算规则')"
            prop='evaluationConfig4Create.othersWeightType'
            required
          >
            <yxt-radio-group v-model="form.evaluationConfig4Create.othersWeightType">
              <div>
                <yxt-radio :label="0">
                  {{ $t('pc_talent_msg_use_weight').d('权重计算') }}
                  <yxt-tooltip
                    class="item v-middle"
                    :content="$t('pc_talent_tips_eval_use_weight').d('除自评外，将他评各个关系按照自身权重进行加权平均计算，举例：他评分=（上级评分*上级权重+平级评分*平级权重+下级评分*下级权重）/（上级权重+平级权重+下级权重）')"
                    placement="top"
                    :max-width="400"
                  >
                    <yxt-svg
                      width="16px"
                      height="16px"
                      icon-class="question-cirlce-o"
                      class="color-gray-6 pb2 hover-primary-6 hand v-mid ml5"
                    />
                  </yxt-tooltip>
                </yxt-radio>
              </div>
              <div class="mt8">
                <div class="eval-self-weight-left">
                  <yxt-radio :label="1">
                    {{ $t('pc_talent_msg_eval_not_use_weight').d('非权重计算') }}
                    <yxt-tooltip
                      :content="$t('pc_talent_tips_eval_not_use_weight').d('除自评外所有人员的评估分平均计算，举例：他评分= （非自评人员评分和）/（非自评人员总数）')"
                      placement="top"
                      :max-width="400"
                    >
                      <yxt-svg
                        width="16px"
                        height="16px"
                        icon-class="question-cirlce-o"
                        class="color-gray-6 hover-primary-6 pb2 hand v-mid ml5"
                      />
                    </yxt-tooltip>
                  </yxt-radio>
                </div>
              </div>
            </yxt-radio-group>
          </yxt-form-item>
        </div>
      </div>
    </yxt-form>
    <yxtbiz-eval-step-footer
      :operation='operation'
      footer-width='960px'
    />
  </div>
</template>

<script>
import { getEvalData, saveEval, syncEvalRelation } from '../service.js';
import infoMixins from '../mixins/info';

const OPERATION_MAP = ['', 'disabled', 'prevDisabled', 'nextDisabled', 'publishDisabled'];

export default {
  mixins: [infoMixins],
  props: {
    parentId: {
      type: String,
      default: ''
    },
    prevId: {
      type: String,
      default: ''
    }
  },

  data() {
    // 校验值是否合法
    const validateSetting = (rule, value, callback) => {
      if (!this.form.autoSync) {
        callback();
        return;
      }
      if (this.weightList && this.weightList.length === 0) {
        callback(
          new Error(this.$t('pc_gwnl_eval_msg_pleaseSetParticipateEval'))
        );
      }

      if (
        this.form.evaluationConfig4Create.enabledLeader === 1 &&
        this.form.evaluationConfig4Create.enabledLeaderDm === 0 &&
        this.form.evaluationConfig4Create.enabledLeaderPm === 0
      ) {
        callback(new Error(this.$t('pc_gwnl_eval_msg_pleaseCheckManager')));
      }
      callback();
    };

    return {
      form: {
        name: '',
        description: '',
        evaluationConfig4Create: {
          enabledSelf: 0,
          enabledEqual: 0,
          enabledSubordinate: 0, // 开启下级评价
          enabledLeader: 0, // 开启上级评价
          enabledLeaderPm: 0, // 上级部门经理评价
          enabledLeaderDm: 0, // 上级的直属经理评价
          weightType: 1, // 权重类型(1-平均权重,2- 自定义权重)
          othersWeightType: 0 // 他评规则(0-权重计算,1-非权重)
        },
        weight: {},
        computedProjects: [], // 完成项目
        autoSync: 1, // 同步评估关系
        dimensionInfo: [{ type: '1' }, { type: '2' }, { type: '3' }, { type: '4' }]
      },
      rules: {
        name: [
          {
            required: true,
            message: this.$t('pc_gwnl_eval_fillEvalName'),
            trigger: 'blur'
          },
          {
            max: 50,
            message: this.$t('pc_gwnl_eval_lengthWithin50'),
            trigger: 'blur'
          }
        ],
        description: [
          {
            max: 200,
            message: this.$t('pc_gwnl_eval_lengthWithin200'),
            trigger: 'blur'
          }
        ],
        evaluationConfig4Create: [{ validator: validateSetting }],
        weight: [{ validator: this.validateWeight }]
      },
      operation: {
        disabled: false,
        nextDisabled: false,
        next: this.next,
        prev: false,
        save: this.save,
        saveName: this.$t('pc_gwnl_global_btn_saveDraft' /* 保存草稿 */)
      },
      prevEvaluationConfig: {}
    };
  },
  created() {
    this.getEvalInfo();
  },
  methods: {
    // 获取方案信息
    async getEvalInfo() {
      if (!this.id) {
        await this.getPrevEvaluationConfig();
        return;
      };
      this.loading = true;
      this.expend = true;
      await this.getBehaviorList(this.id);
      getEvalData(this.id).then(res => {
        this.loading = false;
        let {
          name,
          type,
          description,
          autoSync,
          evaluationConfig
        } = res;

        this.setCustomEvalConfig(evaluationConfig);

        this.form = {
          name,
          description,
          autoSync,
          type,
          evaluationConfig4Create: evaluationConfig
        };

        this.updateEvaluationConfig(evaluationConfig);
      }).catch(err => {
        this.loading = false;
        this.handleError(err);
      });
    },

    getConfigType(config) {
      const arr = [];
      if (config.enabledSelf) {
        arr.push({ type: '1' });
      }

      if (config.enabledLeader) {
        arr.push({ type: '2' });
      }
      if (config.enabledEqual) {
        arr.push({ type: '3' });
      }
      if (config.enabledSubordinate) {
        arr.push({ type: '4' });
      }

      (config.customEvalConfigs || []).forEach(item => {
        arr.push({
          ...item,
          type: item.relationType,
          isDefault: 1
        });
      });

      return arr;
    },

    // 根据prevEvaluationConfig设置对应自定义权重的显示
    setPrevConfig() {
      const { weightType, othersWeightType } = this.form.evaluationConfig4Create;
      // 设置自定义的type到 form.evaluationConfig4Create上
      // 这里的prevEvaluationConfig最后是为了赋值给form.evaluationConfig4Create
      this.setCustomEvalConfig(this.prevEvaluationConfig);

      this.form.evaluationConfig4Create = { ...this.prevEvaluationConfig, weightType, othersWeightType };

      // 更新this.weight的值
      this.updateEvaluationConfig(this.prevEvaluationConfig);
      // 获取所有评估关系，进行显示，最后设置自定义权重对应关系
      const relationList = this.getConfigType(this.prevEvaluationConfig);
      this.setRelations(relationList);
    },

    // 当创建多次行为评估关系子评估时，获取父评估的配置，赋值给子行为评估
    // 页面上无显示，必须勾选对应的权限或者规则，才按照父行为配置的显示
    // 同时如果自动同步父行为关系时，评估设置是不显示出来的
    getPrevEvaluationConfig() {
      if (!this.prevId) return;
      getEvalData(this.prevId).then(res => {
        if (res && res.evaluationConfig) {
          this.prevEvaluationConfig = res.evaluationConfig;
          this.setPrevConfig();
        }
      }).catch(err => {
        this.handleError(err);
      });
    },

    reset() {
      this.resetData();
      // 需要等待数据回显到form表单后再清理验证
      this.$nextTick(this.$refs.form.clearValidate);
      this.loading = false;
    },

    // 调用保存接口方法
    postEvalInfo(callback, option) {
      let {
        name,
        description,
        autoSync,
        evaluationConfig4Create
      } = this.form;
      name = name.trim();
      evaluationConfig4Create = { ...evaluationConfig4Create, ...this.weight };
      evaluationConfig4Create.customEvalConfigs = [];

      // 处理自定义评估关系
      this.evalRelation && this.evalRelation.forEach(item => {
        if (item.isDefault && this.weight[item.weight]) {
          evaluationConfig4Create.customEvalConfigs.push({
            relationType: item.type,
            dimensionName: item.label,
            weight: this.weight[item.weight] || 0
          });
        }
      });

      let data = {
        mubeParentEvalId: this.parentId,
        name,
        type: 4,
        autoSync,
        description,
        scene: 1,
        sourceType: this.sourceType,
        evaluationConfig4Create,
        evalPurpose: 3
      };
      if (this.id) data.id = this.id;

      // 新增、保存
      this.operation[`${OPERATION_MAP[option]}`] = true;
      this.isSubmitting = true;
      saveEval(data).then(res => {
        this.operation[`${OPERATION_MAP[option]}`] = false;
        if (res.Location && !this.id) {
          const id = res.Location.split('saveEvaluation/')[1];
          // 首次创建需要测评绑定地图关系
          this.bindMap(id, 1);
          // 保存即更新id给父组件
          this.$emit('save', id);
          if (this.form.autoSync) {
            syncEvalRelation({
              evaluationId: id,
              orgId: window.localStorage.getItem('orgId') || ''
            });
          }
        }
        this.isSubmitting = false;
        if (option === 1) {
          this.$message.success(
            this.$t('pc_gwnl_global_msg_savedSuccessfully')
          );
        }
        if (callback) {
          callback();
        }
      }).catch(() => {
        this.operation[`${OPERATION_MAP[option]}`] = false;
        this.isSubmitting = false;
      });
    },

    async getBehaviorList(id = '') {
      await this.getListAndSetRelation(id, 'dimensionInfo');
    },

    async onAutoSyncChanged(v) {
      if (v) {
        this.setPrevConfig();
        this.setAverageWeight();
      } else {
        await this.getBehaviorList();
        this.checkedAllDimension();
      }
    }
  }
};
</script>

<style lang='scss' scoped>
.gwnl-position-eval__info {
  padding: 0 24px 40px 0;

  ::v-deep .yxt-form-item__tooltip svg {
    width: 100% !important;
  }

  .weight-item {
    max-width: calc(100% - 24px);
    margin-right: 16px;
  }
}
</style>
